import { useEffect } from 'react'
import { Map } from 'immutable'
import _get from 'lodash/get'
import _map from 'lodash/map'
import _parseInt from 'lodash/parseInt'
import _split from 'lodash/split'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'
import { useMutation } from '@apollo/client'
import { getBoundActions } from '../../actions/index'
import { URL_PLAYLIST_WATCH_LATER, URL_PLAYLIST } from '../../services/url/constants'
import { getAuthIsLoggedIn } from '../../services/auth/index'
import { TYPE_LOGIN } from '../../services/dialog/index'
import { TYPE_CONTENT_VIDEO } from '../../services/content-type/index'
import { ADD_TO_PLAYLIST, CREATE_PLAYLIST } from '../../services/playlist/query'
import { handleRedirect } from './utils'

function GoAddToPlaylist (props) {
  const {
    setOverlayDialogVisible,
    staticText,
    addToasty,
    location,
    history,
    authJwt,
    user,
    auth,
  } = props

  const isLoggedIn = getAuthIsLoggedIn(auth)
  const playlistCreate = _get(location, ['query', 'playlistCreate'])
  const idsString = _get(location, ['query', 'contentIds'])
  const contentIds = _map(_split(idsString, ','), _parseInt)

  const [
    createPlaylist,
    { error: createPlaylistError },
  ] = useMutation(CREATE_PLAYLIST, {
    context: {
      jwt: authJwt,
    },
  })

  const [
    addToPlaylist,
    { error: addToPlaylistError },
  ] = useMutation(ADD_TO_PLAYLIST, {
    onQueryUpdated: (observableQuery) => {
      return observableQuery.refetch()
    },
    context: {
      jwt: authJwt,
    },
  })

  const addPlaylistItems = async (playlistType) => {
    if (contentIds && contentIds.length > 0) {
      const promises = contentIds.map((contentId) => addToPlaylist({
        variables: {
          contentId,
          contentType: TYPE_CONTENT_VIDEO,
          playlistType,
        },
      }))
      await Promise.all(promises)

      if (addToPlaylistError) {
        addToasty(staticText.get('addToPlaylistError'))
      }
    }
  }

  const handleCreatePlaylist = async () => {
    if (playlistCreate) {
      const result = await createPlaylist({
        variables: {
          playlistName: playlistCreate,
        },
      })

      if (createPlaylistError) {
        addToasty(staticText.get('playlistErrorMessage'))
      } else {
        const playlist = _get(result, ['data', 'playlistCreate', 'playlist'])
        const playlistType = _get(playlist, ['playlistType'])

        await addPlaylistItems(playlistType)

        addToasty(staticText.get('playlistSuccessMessage'))

        handleRedirect({
          history,
          auth,
          user,
          url: `${URL_PLAYLIST}/${playlistType}`,
        })
      }
    } else {
      handleRedirect({
        history,
        auth,
        user,
        url: URL_PLAYLIST_WATCH_LATER,
      })
    }
  }

  useEffect(() => {
    if (!isLoggedIn) {
      setOverlayDialogVisible(TYPE_LOGIN)
    } else {
      handleCreatePlaylist()
    }
  }, [isLoggedIn])

  return null
}

GoAddToPlaylist.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  addToasty: PropTypes.func.isRequired,
  setOverlayDialogVisible: PropTypes.func.isRequired,
}

export default connectRedux((state) => ({
  auth: state.auth,
  user: state.user,
  authJwt: state.auth.get('jwt'),
  staticText: state.staticText.getIn(['data', 'goPage', 'data'], Map()) || Map(),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    addToasty: actions.toasty.addToasty,
    setOverlayDialogVisible: actions.dialog.setOverlayDialogVisible,
  }
})(GoAddToPlaylist)
